var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import get from 'lodash/get';
import { useRef, useCallback, useEffect } from 'react';
import { useGetManyReference, useRecordContext, useResourceContext, useRegisterMutationMiddleware, useDataProvider, useNotify, composeSyncValidators, useGetValidationErrorMessage, useSaveContext, } from 'react-admin';
import { useFieldArray, useFormContext } from 'react-hook-form';
import omit from 'lodash/omit';
import isEqual from 'lodash/isEqual';
import { ReferenceManyInputPrefix } from './constants';
import { useMutation } from 'react-query';
export var useReferenceManyInputController = function (options) {
    var reference = options.reference, target = options.target, _a = options.source, source = _a === void 0 ? 'id' : _a, _b = options.page, page = _b === void 0 ? 1 : _b, _c = options.perPage, perPage = _c === void 0 ? 25 : _c, _d = options.sort, sort = _d === void 0 ? { field: 'id', order: 'DESC' } : _d, filter = options.filter, defaultValue = options.defaultValue, validate = options.validate, _e = options.queryOptions, queryOptions = _e === void 0 ? {} : _e, _f = options.mutationOptions, mutationOptions = _f === void 0 ? {} : _f;
    var saveContext = useSaveContext();
    if (saveContext.mutationMode === 'undoable') {
        throw new Error('ReferenceManyInputController cannot be used with undoable mutations. Set mutationMode="optimistic" or mutationMode="pessimistic" in the parent <Edit> or <Create>.');
    }
    var dataProvider = useDataProvider();
    var notify = useNotify();
    var resource = useResourceContext(options);
    var record = useRecordContext(options);
    var sanitizedValidate = Array.isArray(validate)
        ? composeSyncValidators(validate)
        : validate;
    var getValidationErrorMessage = useGetValidationErrorMessage();
    /**
     * Prepare the field array
     *
     * As the edited record does not contains the references in a one-to-many
     * relationship, we have to store them in a temporary field in the current form,
     * named according to the one-to-many configuration.
     * This field will be removed from the form values before the final submit
     * */
    var temporaryFieldName = getReferenceManyFormField({
        resource: resource,
        reference: reference,
        target: target,
    });
    var form = useFormContext();
    var getValues = form.getValues;
    var fieldArray = useFieldArray({
        name: temporaryFieldName,
        rules: {
            validate: function (value) { return __awaiter(void 0, void 0, void 0, function () {
                var error;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!sanitizedValidate)
                                return [2 /*return*/, true];
                            return [4 /*yield*/, sanitizedValidate(value, form.getValues(), options)];
                        case 1:
                            error = _a.sent();
                            if (!error)
                                return [2 /*return*/, true];
                            return [2 /*return*/, getValidationErrorMessage(error)];
                    }
                });
            }); },
        },
    });
    /**
     * Get the records related to the current value
     */
    var references = useRef([]);
    var enabled = typeof record === 'object' && record.hasOwnProperty(source);
    var fillDefaultValue = useCallback(function () {
        form.setValue(temporaryFieldName, defaultValue.map(function (value) { return (__assign({}, value)); }), { shouldDirty: true });
    }, [defaultValue, form, temporaryFieldName]);
    // Apply defaultValue in case of Create
    var defaultValueAppliedStep1 = useRef(false);
    var defaultValueAppliedStep2 = useRef(false);
    useEffect(function () {
        var _a;
        // Only apply this effect in Create mode
        if (enabled)
            return;
        // Only apply this effect if there is a defaultValue
        if (!defaultValue || !defaultValue.length)
            return;
        // Step 1: call fillDefaultValue() to initialize the fieldArray
        if (!defaultValueAppliedStep1.current) {
            fillDefaultValue();
            defaultValueAppliedStep1.current = true;
        }
        // Step 2: call fillDefaultValue() again to set the default values
        // (because they are overriden once the children inputs are mounted)
        if (defaultValueAppliedStep1.current &&
            !defaultValueAppliedStep2.current &&
            ((_a = getValues(temporaryFieldName)) === null || _a === void 0 ? void 0 : _a.length) === defaultValue.length) {
            fillDefaultValue();
            defaultValueAppliedStep2.current = true;
        }
    }, [
        defaultValue,
        enabled,
        fillDefaultValue,
        getValues,
        temporaryFieldName,
    ]);
    var queryMeta = queryOptions.meta, otherQueryOptions = __rest(queryOptions, ["meta"]);
    var _g = useGetManyReference(reference, {
        target: target,
        id: get(record, source),
        pagination: { page: page, perPage: perPage },
        sort: sort,
        filter: filter,
        meta: queryMeta,
    }, __assign(__assign({}, otherQueryOptions), { enabled: enabled, onSuccess: function (res) {
            // filter out not found references - happens when the dataProvider doesn't guarantee referential integrity
            var finalData = res.data ? res.data.filter(Boolean) : [];
            references.current = finalData;
            if (finalData.length === 0 && defaultValue) {
                fillDefaultValue();
            }
            else {
                form.setValue(temporaryFieldName, finalData, {
                    shouldDirty: false,
                    shouldValidate: false,
                    shouldTouch: false,
                });
            }
            if (otherQueryOptions.onSuccess) {
                otherQueryOptions.onSuccess(res);
            }
        }, refetchOnReconnect: false, refetchOnWindowFocus: false })), error = _g.error, isLoading = _g.isLoading, isFetching = _g.isFetching, refetch = _g.refetch;
    var mutationMeta = mutationOptions.meta, otherMutationOptions = __rest(mutationOptions, ["meta"]);
    /**
     * Handle the submit of the form
     */
    var mutateAsync = useMutation(function (_a) {
        var resource = _a.resource, params = _a.params, options = _a.options, next = _a.next;
        return __awaiter(void 0, void 0, void 0, function () {
            var data, otherParams, onSuccess, otherOptions, newReferences, sanitizedData, handleSuccess;
            var _b;
            return __generator(this, function (_c) {
                data = params.data, otherParams = __rest(params, ["data"]);
                onSuccess = options.onSuccess, otherOptions = __rest(options, ["onSuccess"]);
                newReferences = ((_b = get(data, temporaryFieldName)) !== null && _b !== void 0 ? _b : []);
                sanitizedData = omit(data, temporaryFieldName.split('.')[0]);
                handleSuccess = function (data) { return __awaiter(void 0, void 0, void 0, function () {
                    var oldReferencesById, newReferencesById, removedReferences, addedReferences, updatedReferences, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                oldReferencesById = references.current.reduce(function (acc, reference) {
                                    var _a;
                                    return (__assign(__assign({}, acc), (_a = {}, _a[reference.id] = reference, _a)));
                                }, {});
                                newReferencesById = newReferences.reduce(function (acc, reference) {
                                    var _a;
                                    return (__assign(__assign({}, acc), (_a = {}, _a[reference.id] = reference, _a)));
                                }, {});
                                removedReferences = references.current.filter(function (reference) { return !newReferencesById.hasOwnProperty(reference.id); });
                                addedReferences = newReferences.filter(
                                // new references don't yet have an id
                                function (reference) { return !reference.hasOwnProperty('id'); });
                                updatedReferences = newReferences.filter(function (reference) {
                                    // not a new reference
                                    return reference.hasOwnProperty('id') &&
                                        // reference has changed
                                        !isEqual(oldReferencesById[reference.id], reference);
                                });
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 8, , 9]);
                                if (!(removedReferences.length > 0)) return [3 /*break*/, 3];
                                return [4 /*yield*/, dataProvider.deleteMany(reference, {
                                        ids: removedReferences.map(function (_a) {
                                            var id = _a.id;
                                            return id;
                                        }),
                                        meta: mutationMeta,
                                    })];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3:
                                if (!(updatedReferences.length > 0)) return [3 /*break*/, 5];
                                return [4 /*yield*/, Promise.all(updatedReferences.map(function (updatedReference) {
                                        return dataProvider.update(reference, {
                                            id: updatedReference.id,
                                            data: updatedReference,
                                            previousData: references.current.find(function (oldRef) {
                                                return oldRef.id === updatedReference.id;
                                            }),
                                            meta: mutationMeta,
                                        });
                                    }))];
                            case 4:
                                _a.sent();
                                _a.label = 5;
                            case 5:
                                if (!(addedReferences.length > 0)) return [3 /*break*/, 7];
                                return [4 /*yield*/, Promise.all(addedReferences.map(function (addedReference) {
                                        var _a;
                                        return dataProvider.create(reference, {
                                            data: __assign(__assign({}, addedReference), (_a = {}, _a[target] = get(data, source), _a)),
                                            meta: mutationMeta,
                                        });
                                    }))];
                            case 6:
                                _a.sent();
                                _a.label = 7;
                            case 7: return [3 /*break*/, 9];
                            case 8:
                                error_1 = _a.sent();
                                notify('ra-relationships.referenceManyInput.saveError', {
                                    type: 'error',
                                    messageArgs: {
                                        _: 'Server error: your changes were not completely saved',
                                    },
                                });
                                // do not execute success side effects
                                return [2 /*return*/];
                            case 9:
                                if (sanitizedData.hasOwnProperty(source)) {
                                    // if we're in an edit page (not a create page)
                                    // force refresh (and update of references.current) to allow further saves
                                    refetch();
                                }
                                if (onSuccess) {
                                    onSuccess(data);
                                }
                                return [2 /*return*/];
                        }
                    });
                }); };
                next(resource, __assign(__assign({}, otherParams), { data: sanitizedData }), __assign(__assign({}, otherOptions), { onSuccess: handleSuccess }));
                return [2 /*return*/];
            });
        });
    }, __assign({}, otherMutationOptions)).mutateAsync;
    var middleware = useCallback(function (resource, params, options, next) {
        return mutateAsync({ resource: resource, params: params, options: options, next: next });
    }, [mutateAsync]);
    useRegisterMutationMiddleware(middleware);
    return {
        fieldArray: fieldArray,
        error: error,
        isLoading: isLoading,
        isFetching: isFetching,
        refetch: refetch,
        temporaryFieldName: temporaryFieldName,
    };
};
/**
 * Get virtual field name
 *
 * The '0.{reference} suffix is there to trigger a correct default label
 * (see <FieldTitle> for details)
 *
 * @example
 * getReferenceManyFormField({ resource: 'teachers', referecne: 'students', target: 'teacher_id' })
 * // @@ra-many/teachers/students/teacher_id.0.students
 */
export var getReferenceManyFormField = function (_a) {
    var resource = _a.resource, reference = _a.reference, target = _a.target;
    return "".concat(ReferenceManyInputPrefix).concat(resource, "/").concat(reference, "/").concat(target, ".0.").concat(reference);
};
